const getCurrentAttempts = () => {
  let currentAttempts = null

  try {
    currentAttempts = parseInt(localStorage.getItem('smsAttempts')) || 0
  } catch (err) {
    return false
  }

  return currentAttempts
}

const incrementCurrentAttempts = () => {
  let currentAttempts = getCurrentAttempts()

  try {
    localStorage.setItem('smsAttempts', currentAttempts + 1)
  } catch (err) {
    return false
  }

  return true
}

export { getCurrentAttempts, incrementCurrentAttempts }
